import React, { FC } from 'react'
import styled from 'styled-components'
import { Annotation } from './Annotation'
import { AnchorTypes, AnnotationType } from '../AnnotatedElement/types'
import { Debug } from './Debug'
import { useElementSize } from 'usehooks-ts'

type DefaultsType = {
  content?: React.ReactNode
  anchor?: AnchorTypes
  distance?: number
  Marker?: React.ReactNode
  left?: number
  top?: number
  connect?: boolean
  connector?: Partial<ConnectorType>
}

export interface AnnotationElementProps {
  children?: React.ReactNode
  defaults?: DefaultsType
  annotations?: AnnotationType[]
  debug?: boolean
  move?: { x: number; y: number }
}
const presets: DefaultsType = {
  anchor: 'top-right',
  distance: 0,
  left: 0,
  top: 0,

  connector: {
    type: 'straight',
    style: { stroke: '#000' },
    direction: 'clockwise',
  },
}
export const AnnotationElement: FC<AnnotationElementProps> = ({
  children,
  annotations,
  defaults = {},
  debug,
  move,
}) => {
  const [mainElement, mainSize] = useElementSize()
  const m = move || { x: 0, y: 0 }
  return (
    <AnnotationElementRoot className='AnnotatedElement' move={m}>
      <AnnotationElementContainer ref={mainElement}>
        {children && children}
      </AnnotationElementContainer>
      <AnnotationContainer className='anno_container'>
        {annotations &&
          annotations.map((annotation) => {
            const Marker =
              annotation.Marker === false
                ? undefined
                : annotation.Marker || defaults.Marker
            const { left, top, content, anchor, distance, connect } = {
              ...presets,
              ...defaults,
              ...annotation,
            }
            const connector = {
              ...presets.connector,
              ...defaults.connector,
              ...annotation.connector,
            }

            return (
              <>
                {debug && <Debug size={mainSize} />}
                <Annotation
                  left={left}
                  top={top}
                  anchor={anchor as AnchorTypes}
                  distance={connect ? distance : 0}
                  connect={connect}
                  connector={connector}
                  Marker={Marker}
                  
                >
                  {content && content}
                </Annotation>
              </>
            )
          })}
      </AnnotationContainer>
    </AnnotationElementRoot>
  )
}

const AnnotationElementRoot = styled.div<{
  move: { x: number; y: number }
}>`
  transition: margin-top 1s linear, margin-left 1s linear;
  position: relative;
  display: inline-block;
  margin-top: ${({ move }) => move.y + 'px'};
  margin-left: ${({ move }) => move.x + 'px'};
  max-width: 100%;
  overflow: hidden;

`
const AnnotationElementContainer = styled.div`

`
const AnnotationContainer = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
`
